/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 * Extracted ability-template data (was part of Abilities.ts). Pure data; consumed by Abilities.
*/

export const legendary_actions: Ability[] = [
		{
			label: "Attack",
			name: "??? Attack",
			desc: "The [MON] makes a ??? attack.",
			group: "Legendary Actions"
		},
		{
			name: "Detect",
			desc: "The [MON] makes a Wisdom (Perception) check.",
			group: "Legendary Actions"
		},
		{
			name: "Teleport",
			desc: "The [MON] magically teleports, along with any equipment it is wearing or carrying, up to 120 feet to an unoccupied space it can see.",
			group: "Legendary Actions"
		},
		{
			label: "Wing Attack",
			name: "Wing Attack (Costs 2 Actions)",
			desc: "The [MON] beats its wings. Each creature within ??? ft. of the [MON] must succeed on a DC ??? Dexterity saving throw or take [STR ???d???] bludgeoning damage and be knocked prone. The [MON] can then fly up to half its flying speed.",
			group: "Legendary Actions"
		},
	];
